// extracted by mini-css-extract-plugin
export default {"container":"_kXaW1yG","skeleton":"UXOZkS7U"};